import { useMemo } from "react";

import createClient from "openapi-fetch";

import { paths } from "../generated/client";
import { getBackendUri } from "../lib/utils/getBackendUrl";

export const useBackendClient = () => {
  const backendUrl = getBackendUri();
  return useMemo(() => {
    return createClient<paths>({ baseUrl: backendUrl });
  }, [backendUrl]);
};
